import { HTTP, authHeader, HTTP_FILE } from './http-service';

class DataSubjectAccessRequestEvidenceService {
  evidenceList(dsarId) {
    return HTTP.get(`/DataSubjectAccessRequestEvidence/dsar/${dsarId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  get(dsarId, dsarEvidenceId) {
    return HTTP.get(`/DataSubjectAccessRequestEvidence/${dsarEvidenceId}/dsar/${dsarId}/`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post(`/DataSubjectAccessRequestEvidence`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  update(payload) {
    return HTTP.put(`/DataSubjectAccessRequestEvidence`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      },
    );
  }

  delete(payload) {
    return HTTP.delete(
      `/DataSubjectAccessRequestEvidence/${payload.dsarEvidenceId}/dsar/${payload.dsarId}`,
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  getSignedUrl(dsarId, filename) {
    return HTTP_FILE.get(
      `/DataSubjectAccessRequestFile/GetPresignedPost/${dsarId}?filename=${encodeURIComponent(filename)}`,
    ).then((response) => {
      return response.data;
    });
  }

  getDownloadUrl(link) {
    return HTTP_FILE.get(`/DataSubjectAccessRequestFile/download/${encodeURIComponent(link)}`).then(
      (response) => {
        return response.data;
      },
    );
  }

  deleteFile(link) {
    return HTTP_FILE.delete(`/DataSubjectAccessRequestFile/${encodeURIComponent(link)}`).then(
      (response) => {
        return response.data;
      },
    );
  }
}

export default new DataSubjectAccessRequestEvidenceService();
